<template>
    <div class="row">
        <div class="col">
            <div
                v-if="showRenewWarning()"
                class="mb-4 bg-blue-100 border-l-4 border-blue-500 text-blue-700 px-4 py-3"
                role="alert"
            >
                <h4 class="mb-1 font-semibold text-base text-blue-800">Follow Up Required</h4>
                <p class="mb-1">You currently have a pending invoice for this domain - {{ domain['domainname']}}.</p>
                <p class="m-0 leading-3">Please note that disabling auto renewal will not cancel the pending invoice. If you wish to do so, please contact our billing team <a href="mailto:billing@serversaustralia.com.au">billing@serversaustralia.com.au</a>.</p>
            </div>

            <div class="sau-bx bx-pad clearfix text-center">
                <div class="row">
                    <div class="col">
                        <h4>Auto Renewal ({{ willRenew() ? 'on' : 'off' }})</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p>Auto-Renew means that when your domain comes up for renewal, we will automatically invoice you for it. If you have a credit card saved on your account, your card will be charged, and your domain renewed. </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button
                            v-if="canUpdateDomain"
                            :disabled="submitting"
                            @click.prevent="submit()"
                            :class="[willRenew() ? 'btn-danger' : 'btn-success', 'btn bt-lg  mx-auto']"
                        >
                            {{ willRenew() ? 'Turn Off' : 'Turn On' }} <i v-if="submitting" class="far fa-spinner-third fa-spin"></i>
                        </button>
                        <p v-else>
                            This functionality is not available on cancelled domains.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['domain', 'has-invoice'],
        data() {
            return {
                submitting: false,
            };
        },
        methods: {
            showRenewWarning() {
                return this.hasInvoice;
            },
            willRenew() {
                if (window.parseInt(this.domain.donotrenew) === NaN) {
                    this.domain.donotrenew = this.domain.donotrenew ? 1 : 0;
                }

                return ! window.parseInt(this.domain.donotrenew);
            },

            submit() {
                this.submitting = true;
                this.updateAutoRenewalStatus().then(response => {
                    if (response.data.status === 'success') {
                        if (response.data.data && response.data.data.result === 'success') {
                            this.$swal({
                                type:'success',
                                title: 'Auto Renewal Updated',
                                showConfirmButton: false,
                                timer: 3000
                            });

                            if (window.parseInt(this.domain.donotrenew) === NaN) {
                                this.domain.donotrenew = this.domain.donotrenew ? 1 : 0;
                            }

                            this.domain.donotrenew = ! window.parseInt(this.domain.donotrenew) ? 1 : 0;
                        } else {
                            this.$swal({
                                type:'error',
                                title: 'Failed to update auto renewal status',
                                html: `
                                    We were unable to update the auto renewal status of this domain.<br />
                                    ${(response.data.data.message || '')} - ${(response.data.data.error)}
                                `,
                                showConfirmButton: true,
                                confirmButtonClass: 'btn btn-danger',
                                buttonsStyling: false,
                            });
                        }
                    } else {
                        this.$swal({
                            type:'error',
                            title: 'Failed to update auto renewal status',
                            html: response.data.message,
                            showConfirmButton: true,
                            confirmButtonClass: 'btn btn-danger',
                            buttonsStyling: false,
                        });
                    }

                    this.submitting = false;
                })
            },
        },
    }
</script>
